import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_LAW_EXPENSES = 'GET_LAW_EXPENSES';
export const GET_LAW_EXPENSE = 'GET_LAW_EXPENSE';
export const CREATE_LAW_EXPENSE = 'CREATE_LAW_EXPENSE';
export const UPDATE_LAW_EXPENSE = 'UPDATE_LAW_EXPENSE';
export const DELETE_LAW_EXPENSE = 'DELETE_LAW_EXPENSE';

// Get all expenses
export const getLawExpenses = (caseId, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchLawExpenses(caseId, page, pageSize);

    dispatch({
      type: GET_LAW_EXPENSES,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching expenses:', error);
    throw error;
  }
};

// Get single expense
export const getLawExpense = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchLawExpense(id);

    dispatch({
      type: GET_LAW_EXPENSE,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching expense:', error);
    throw error;
  }
};

// Create expense
export const createLawExpense = (expenseData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createLawExpense(expenseData);

    dispatch({
      type: CREATE_LAW_EXPENSE,
      payload: data
    });

    openSnackbar('Expense created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Expense created successfully"));

    return data;
  } catch (error) {
    console.error('Error creating expense:', error);
    openSnackbar('Error creating expense', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating expense"));
    throw error;
  }
};

// Update expense
export const updateLawExpense = (id, expenseData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateLawExpense(id, expenseData);

    dispatch({
      type: UPDATE_LAW_EXPENSE,
      payload: data
    });

    openSnackbar('Expense updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Expense updated successfully"));

    return data;
  } catch (error) {
    console.error('Error updating expense:', error);
    openSnackbar('Error updating expense', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating expense"));
    throw error;
  }
};

// Delete expense
export const deleteLawExpense = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteLawExpense(id);

    dispatch({
      type: DELETE_LAW_EXPENSE,
      payload: id
    });

    openSnackbar('Expense deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Expense deleted successfully"));
  } catch (error) {
    console.error('Error deleting expense:', error);
    openSnackbar('Error deleting expense', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting expense"));
    throw error;
  }
};
